export default __webpack_public_path__ + "static/media/close-button-icon.dd287d17.svg";